import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ArrowOutward from "@mui/icons-material/ArrowOutward";
import ArrowForward from "@mui/icons-material/ArrowForward";
import Navigation from "./Navigation";
import Footer from "./Footer";
import { usePageMeta } from "../utils/usePageMeta";
import { useSiteMotion, WorkerCursor } from "./motion/SiteMotion";
import ProductScene from "./motion/ProductScenes";
import PioneerHorizon from "./motion/PioneerHorizon";
import WorkerSwarm from "./motion/Swarm";
import "../styles/brand-motion.css";
export const DEMO_URL = "https://calendar.app.google/CE8yHXidRV2hsSRS9";
export const RELEASE_URL =
  "https://github.com/geniusgeek/meeting-machine-releases/releases/latest/download";
export function SiteShell({
  title,
  description,
  image = "/brand/journal-worker.png",
  path,
  children,
  className = "",
}) {
  usePageMeta(title, description, { image, path });
  useSiteMotion();
  return (
    <div className={"grupa-site " + className}>
      <Navigation />
      <main id="main-content" tabIndex="-1">
        {children}
      </main>
      <Footer />
      <WorkerCursor />
      <WorkerSwarm />
    </div>
  );
}
export function RoutePosition() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const frame = requestAnimationFrame(() =>
        document
          .getElementById(decodeURIComponent(hash.slice(1)))
          ?.scrollIntoView(),
      );
      return () => cancelAnimationFrame(frame);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
export function BrandLink({
  to,
  children,
  secondary = false,
  className = "",
  ...props
}) {
  const classes =
    "brand-button" + (secondary ? " brand-button-secondary " : " ") + className;
  return to.startsWith("/") ? (
    <Link className={classes} to={to} {...props}>
      {children}
      <ArrowForward fontSize="small" />
    </Link>
  ) : (
    <a className={classes} href={to} {...props}>
      {children}
      <ArrowOutward fontSize="small" />
    </a>
  );
}
export function SectionHead({ eyebrow, title, children }) {
  return (
    <div className="brand-section-head">
      <div>
        <span className="brand-eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
      </div>
      {children && <p>{children}</p>}
    </div>
  );
}
export function NextChapter({
  eyebrow = "The next chapter",
  title = "Make room for more.",
  text = "Bring your ambition. We will bring the workers.",
  to = "/desktop#downloads",
  label = "Meet Momentum",
  secondaryLink,
}) {
  return (
    <section className="brand-next">
      <PioneerHorizon />
      <div className="brand-container">
        <span className="brand-eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
        <div className="brand-next-bottom">
          <p>{text}</p>
          {secondaryLink ? (
            <div className="brand-next-actions">
              <BrandLink to={to}>{label}</BrandLink>
              <Link className="brand-text-link" to={secondaryLink.to}>
                {secondaryLink.label}
                <ArrowForward fontSize="small" />
              </Link>
            </div>
          ) : (
            <BrandLink to={to}>{label}</BrandLink>
          )}
        </div>
      </div>
    </section>
  );
}
export function ProductPaths() {
  const products = [
    [
      "01",
      "Momentum",
      "Your personal worker.",
      "A digital humanoid across your devices. Set the mission and follow the work.",
      "/desktop#downloads",
    ],
    [
      "02",
      "Workspace",
      "Your agents, working together.",
      "Digital humanoid teams coordinate on your behalf and bring you in only when needed.",
      "/workspace",
    ],
    [
      "03",
      "Workers API",
      "Build your company on it.",
      "Create AI-native businesses and agent products on GrupaAI's worker infrastructure.",
      "/api",
    ],
  ];
  return (
    <div className="brand-product-paths">
      {products.map(([n, title, subtitle, text, to], i) => (
        <Link to={to} key={title}>
          <span className="brand-caption">
            {n} / {title}
          </span>
          <ProductScene index={i} />
          <h3>{subtitle}</h3>
          <p>{text}</p>
          <ArrowOutward />
        </Link>
      ))}
    </div>
  );
}
